/** 页面尺寸比例预设（固定像素尺寸） */

export const DEFAULT_PAGE_RATIO_ID = '3:4';

export const PAGE_RATIO_PRESETS = [
  { id: '1:1', label: '1:1', width: 2000, height: 2000 },
  { id: '3:4', label: '3:4', width: 1340, height: 1785 },
  { id: '4:3', label: '4:3', width: 1785, height: 1340 },
  { id: '16:9', label: '16:9', width: 2000, height: 1125 },
  { id: '9:16', label: '9:16', width: 1125, height: 2000 },
];

export function getPresetById(ratioId) {
  return PAGE_RATIO_PRESETS.find((p) => p.id === ratioId)
    || PAGE_RATIO_PRESETS.find((p) => p.id === DEFAULT_PAGE_RATIO_ID);
}

export function getPageSizeForRatio(ratioId) {
  const preset = getPresetById(ratioId);
  return {
    width: preset.width,
    height: preset.height,
    ratioId: preset.id,
  };
}

/** 按当前比例由宽度推算高度 */
export function calcHeightFromWidth(width, ratioId) {
  const preset = getPresetById(ratioId);
  const w = Number(width);
  if (!Number.isFinite(w) || w <= 0) return preset.height;
  return Math.round(w * preset.height / preset.width);
}

/** 按当前比例由高度推算宽度 */
export function calcWidthFromHeight(height, ratioId) {
  const preset = getPresetById(ratioId);
  const h = Number(height);
  if (!Number.isFinite(h) || h <= 0) return preset.width;
  return Math.round(h * preset.width / preset.height);
}

export function detectPageRatioId(width, height) {
  if (!width || !height) return DEFAULT_PAGE_RATIO_ID;
  const ratio = width / height;
  for (const preset of PAGE_RATIO_PRESETS) {
    const presetRatio = preset.width / preset.height;
    if (Math.abs(ratio - presetRatio) < 0.02) return preset.id;
  }
  return 'custom';
}

export function createWorkspaceObject(width, height, fill = 'transparent') {
  return {
    type: 'rect',
    id: 'workspace',
    left: 0,
    top: 0,
    width,
    height,
    fill,
    stroke: '#c8c8c8',
    strokeWidth: 1,
    selectable: false,
    hasControls: false,
    evented: false,
  };
}
